export const es = {
  'app.name': 'RestLab',
  'nav.group': 'Control de grupo',
  'nav.book': 'Reservas',
  'nav.calendar': 'Calendario',
  'nav.waitlist': 'Lista de espera',
  'nav.standards': 'Estándares',
  'nav.migration': 'Migración',
  'nav.alerts': 'Alertas',
  'action.newReservation': 'Nueva reserva',
  'action.save': 'Guardar',
  'action.cancel': 'Cancelar',
  'status.confirmed': 'Confirmada',
  'status.pending': 'Pendiente',
  'status.cancelled': 'Cancelada',
  'status.seated': 'En mesa',
  'status.completed': 'Completada',
  'status.no_show': 'No show',
} as const;
